export default __webpack_public_path__ + "static/box-welcome-dba8dee0f8019f49672e8d464ea29ed7.png";